module.exports = __webpack_public_path__ + "static/media/sort-icon-down.7dae1a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-icon-down.svg
// module id = 573
// module chunks = 1